export function routeToObject(ownerType, ownerID) {
  switch(ownerType) {
    case 'Site':
      return { name: "ShowSite", params: { id: ownerID } };
    case 'Asset':
      return { name: "ShowAsset", params: { id: ownerID } };
    case 'Location':
      return { name: "ShowLocation", params: { id: ownerID } };
    case 'Meter':
      return { name: "ShowMeter", params: { id: ownerID } };
    case 'Emo':
      return { name: "ShowEmo", params: { id: ownerID } };
    case 'Issue':
      return { name: "ShowIssue", params: { id: ownerID } };      
    case 'Note':
      return null;  
    case 'Image':
      return { name: "ShowImage", params: { id: ownerID } };
      
  }
}

export function ownerOfObj(obj) {
  console.log("Inside common/url_path_helper ownerOfObj(): obj ==> ", obj);
  if (obj.owner_uuid) {
    return this.$store.getters.getObjectByUUID(obj.owner_type, obj.owner_uuid)
  } else {
    return null;
  }
}

export function routeToOwner(obj) {
  if (obj.owner_type && obj.owner_uuid) {
    return routeToObject(obj.owner_type, obj.owner_uuid);
  } else {
    return null;
  }
}